export const isAeDomain = () => {
    const hostName = window.location.hostname
    const aeDomain = hostName.includes('cleartrip.ae')
    return aeDomain
}
